import styled from 'styled-components'
import chroma from 'chroma-js'

export const Wrapper = styled.div<{ $height?: number }>`
  display: flex;
  position: relative;
  width: 100%;
  height: ${({ $height }) => ($height ? `${$height}px` : 'auto')};
  padding: 0;
`

export const ActionButtonsWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`

export const ActionButton = styled.button<{
  $variant?: 'neutral' | 'primary' | 'outline'
  $isMaximized?: boolean
  $isExpanded?: boolean
}>`
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-radius: 8px;
  padding: 0.3rem 1rem;
  border: ${({ $variant, theme }) =>
    $variant === 'outline' ? `1px solid ${theme.colors.primary}` : '1px solid transparent'};
  background-color: ${({ $variant, theme }) =>
    $variant === 'primary'
      ? theme.colors.primary
      : $variant === 'outline'
        ? 'transparent'
        : theme.colors.lightGrey};
  color: ${({ $variant, theme }) =>
    $variant === 'primary'
      ? theme.colors.lightText
      : $variant === 'outline'
        ? theme.colors.primary
        : '#363636'};
  font-weight: 600;
  font-size: 0.9rem;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  box-shadow: none;
  transition:
    background-color 0.2s ease,
    color 0.2s ease,
    border-color 0.2s ease;
  flex: ${({ $isMaximized }) => ($isMaximized ? '1' : 'none')};

  svg {
    flex: 0 0 auto;
    fill: currentColor;
  }

  &:hover {
    background-color: ${({ $variant, theme }) =>
      $variant === 'primary'
        ? chroma(theme.colors.primary).darken(0.2).hex()
        : $variant === 'outline'
          ? chroma(theme.colors.primary).alpha(0.08).css()
          : chroma(theme.colors.lightGrey).darken(0.15).hex()};
  }

  &:focus-visible {
    outline: 3px solid ${({ theme }) => chroma(theme.colors.primary).alpha(0.3).css()};
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const MetricsRow = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin: 6px 0px 8px 12px;
`

export const MetricValueWrap = styled.span<{ $variant: 'positive' | 'negative' | 'flat' }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  line-height: 1;
  padding: 6px 10px;
  border-radius: 999px;
  font-weight: 700;

  ${({ $variant }) =>
    $variant === 'positive'
      ? `color:#065f46;background:#d1fae5;border:1px solid #a7f3d0;`
      : $variant === 'negative'
        ? `color:#991b1b;background:#fee2e2;border:1px solid #fecaca;`
        : `color:#374151;background:#f3f4f6;border:1px solid #e5e7eb;`}
`
